import dayjs from "dayjs";
import SyIcon from "../../../../shared/components/sy-icon";

const TimeLineFlagPop = (props: any) => {
  const { flagData, handleCloseClick } = props;
  const getTime = (time: any, format: any) => {
    return dayjs(time).format(format);
  };

  return (
    <div className={`rounded-4  p-3   pop-bg`}>
      <div className="d-flex align-items-center justify-content-between pb-3">
        <h2 className="mohave m-0 title-font">{"timeLine flag"}</h2>
        <SyIcon
          name="close"
          iconType="symbols"
          iconStyle="outlined"
          iconColor="white"
          className={` pointer`}
          onClick={handleCloseClick}
        />
      </div>

      {flagData?.map((data: any) => {
        return (
          <>
            <div className="mb-2 ">
              <p className="mohave text-white mb-0">{data.otl_timeline.tl_action}</p>
              <span className="d-flex justify-content-end ">
                <span className="border-bottom mini-font opacity-50">{`${
                  data.user_name
                }(${getTime(data.created_at, "DD.MM.YYYY")}-${getTime(
                  data.created_at,
                  "h:mm A"
                )})`}</span>
              </span>
            </div>
          </>
        );
      })}
    </div>
  );
};

export default TimeLineFlagPop;
